var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4.00205C6.68744 4.00205 4.00205 6.68744 4.00205 10C4.00205 13.3127 6.68744 15.998 10 15.998C13.3127 15.998 15.998 13.3127 15.998 10C15.998 6.68744 13.3127 4.00205 10 4.00205ZM1.99805 10C1.99805 5.58066 5.58066 1.99805 10 1.99805C14.4194 1.99805 18.002 5.58066 18.002 10C18.002 11.8468 17.3764 13.5475 16.3256 14.9016L21.709 20.292C22.1001 20.6835 22.0997 21.318 21.7081 21.709C21.3166 22.1001 20.6821 22.0997 20.2911 21.7081L14.9094 16.3195C13.554 17.374 11.8504 18.002 10 18.002C5.58066 18.002 1.99805 14.4194 1.99805 10Z",
    fill: ""
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.6c7249b78f48c4d388a7322cdde47123.svg";
export { ForwardRef as ReactComponent };